export default "__VITE_ASSET__4308b70c__"